import { useFormContext } from 'react-hook-form';
import { Avatar } from '@/components/Avatar/Avatar';
import { TextField } from '@/components/TextField/TextField';
import { t } from '@/lib/i18n';
import type { AddWizardValues } from '../../schemas';
import { usePositionsCatalog, useUnitsCatalog } from '../../hooks';
import styles from './StepIdentity.module.css';

export function StepIdentity() {
  const { register, watch } = useFormContext<AddWizardValues>();
  const first = watch('first_name');
  const last = watch('last_name');

  const positions = usePositionsCatalog();
  const units = useUnitsCatalog();

  const displayName = [first, last].filter(Boolean).join(' ') || t('New Member');

  return (
    <section data-testid="step-identity">
      <div className={styles.header}>
        <div className={styles.stepLabel}>{t('STEP 3')}</div>
        <h1 className={styles.title}>{t('Give them a name and a face.')}</h1>
        <p className={styles.subtitle}>
          {t('People work better with people. Pick a name, position, and unit.')}
        </p>
      </div>

      <div className={styles.card}>
        <div className={styles.avatarCol}>
          <Avatar name={displayName} size="lg" kind="ai" />
        </div>

        <div className={styles.fields}>
          <div className={styles.nameRow}>
            <TextField label={t('First name')} {...register('first_name')} />
            <TextField label={t('Last name')} {...register('last_name')} />
          </div>

          <div className={styles.selectRow}>
            <label className={styles.selectField}>
              <span className={styles.selectLabel}>{t('Position')}</span>
              <select
                className={styles.select}
                {...register('positionId')}
                aria-label={t('Position')}
              >
                <option value="">{t('— None —')}</option>
                {positions.data?.items.map((p) => (
                  <option key={p.id} value={p.id}>
                    {p.name}
                  </option>
                ))}
              </select>
            </label>

            <label className={styles.selectField}>
              <span className={styles.selectLabel}>{t('Department')}</span>
              <select
                className={styles.select}
                {...register('unitId')}
                aria-label={t('Department')}
              >
                <option value="">{t('— None —')}</option>
                {units.data?.items.map((u) => (
                  <option key={u.id} value={u.id}>
                    {u.name}
                  </option>
                ))}
              </select>
            </label>
          </div>
        </div>
      </div>
    </section>
  );
}
